// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b1ef5990","27":"410bf52f","99":"48acd845","174":"996c5a96","216":"6b4b5f5e","272":"82139b3d","281":"a1936e2c","310":"8e110333","313":"bc9d32e2","432":"acd69128","627":"a316b3a4","675":"9829c03e","778":"6ac703c1"}[chunkId] + ".chunk.js";
};